import { ApiRequest } from './api.request';
import { QueryParams } from '../../classes/query-params';
import { IResponseModel } from '../../models/interfaces/response-model.interface';
import { AppConstants } from '../../app.constants';
import { TableSortOptions } from '../table-sort-options';
import { NewCursor } from '../new-api-cursor';

export class ApiPagedRequest extends ApiRequest {
    constructor(
        public pathComponents: string[] = [],
        public model: IResponseModel,
        public limit?: number,
        public offset: number = 0,
        public tableSortOptions?: TableSortOptions,
        public cursor?: NewCursor,
        public search?: string,
        public filters?: Record<string, any>,
        public includeTotals: boolean = false
    ) {
        super(pathComponents, model);

        this.limit = this.limit || AppConstants.PAGE_SIZE_MAX;
    }

    protected getQueryParams(): QueryParams {
        const queryParams = new QueryParams()
            .setLimitAndOffsetParams(this.limit, this.offset, this.includeTotals)
            .setSortingParams(this.tableSortOptions)
            .addObject(this.filters);

        if (this.search) queryParams.setSearchParams(this.search);
        if (this.cursor) queryParams.setNewCursor(this.cursor);

        queryParams.addObject(super.getQueryParams().getParams());

        return queryParams;
    }
}
